import Portal from 'components/Portal';
import wordpressData from 'data';
import * as React from 'react';
import SpriteIcon from 'search/components/sprite-icon';
import FiltersConfigurator from './filters-configurator';
import ProductConfiguratorStore from './stores/shower-configurator-store';

const ProductsConfiguratorProductDetail: React.VFC<{
  configurator: ProductConfiguratorStore;
  // title?: string;
  // introduction?: string;
  modal_title?: string;
  modal_content?: string;
}> = ({ configurator, modal_title, modal_content }) => {
  const [, forceRefresh] = React.useReducer((i) => i + 1, 0);
  const [openModal, setOpenModal] = React.useState(false);

  React.useEffect(() => {
    configurator.refresh = forceRefresh;
    configurator.load_configuration(new URLSearchParams(window.location.search).get('configuration'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!configurator.is_loaded) {
    return null;
  }

  // if (!configurator.can_edit) {
  //   return null;
  // }

  const sections = [];

  if (openModal) {
    sections.push(
      <Portal
        key="filters-section"
        onAppend={() => {
          document.documentElement.style.overflow = 'hidden';
        }}
        onRemove={() => {
          document.documentElement.style.overflow = 'visible';
        }}
      >
        <div className="mfp-bg mfp-ready"></div>
        <div className="mfp-wrap mfp-auto-cursor mfp-ready" tabIndex={-1} style={{ overflow: 'hidden auto' }}>
          <div className="mfp-container mfp-s-ready mfp-inline-holder">
            <div className="mfp-content">
              <div className="c-modal__wrapper c-modal__wrapper--lg">
                <div className="c-modal c-modal--has-sidebar">
                  <button onClick={() => setOpenModal(false)} className="c-modal-close" />
                  <div className="c-modal__main">
                    <div className="c-block c-block--spacing-t-small c-block--spacing-b-small u-bg-neutral-800">
                      <div className="o-container-fluid">
                        <div className="o-row">
                          <div className="o-col-12">
                            <div className="u-flex u-items-center u-mb-spacer-base-small">
                              <SpriteIcon
                                name="plans"
                                classes={['o-svg-icon', 'u-mr-spacer-base-small', 'u-h2', 'u-text-secondary']}
                              />
                              <h6 className="c-headline u-mb-0 u-text-secondary">Product configurator</h6>
                            </div>
                            <h2 className="u-text-white">{modal_title}</h2>
                            <p className="u-text-white">{modal_content}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="c-block c-block--spacing-t-small c-block--spacing-b-small">
                      <div className="o-container-fluid">
                        <div className="o-row">
                          <div className="o-col-12">
                            <FiltersConfigurator
                              onSubmit={(specifications) => {
                                configurator.specifications = specifications;
                                if (configurator.type === 'shower') {
                                  window.location.href = wordpressData.productConfigurator.showerPage;
                                }
                              }}
                              configurator={configurator}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mfp-bg mfp-ready"></div>
      </Portal>
    );
  }

  sections.push(
    <section key="starter-section" className="c-info-strip">
      <div className="o-container">
        <div className="o-row">
          <div className="o-col-12">
            <div className="c-info-strip__inner">
              <span className="c-info-strip__icon">
                <SpriteIcon name="info" classes={['o-svg-icon']} />
              </span>
              <p className="c-info-strip__note">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                <a
                  onClick={() => {
                    setOpenModal(true);
                  }}
                >
                  Edit your answers
                </a>
                {' or '}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                <a
                  onClick={(event) => {
                    event.preventDefault();
                    // configurator.delete_local_storage();
                    if (configurator.type === 'shower') {
                      window.location.href = wordpressData.productConfigurator.showerPage;
                    }
                  }}
                >
                  go back to your shower results
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return <>{sections}</>;
};
export default ProductsConfiguratorProductDetail;
